import React, { useEffect, useState } from "react";
import Button from "../Component/Button";
import Footer from "../Component/Footer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowDownLong,
  faCircleInfo,
  faDownload,
  faFileDownload,
  faPenSquare,
} from "@fortawesome/free-solid-svg-icons";
import LineComp from "../Component/LineComp";
import { useSelector } from "react-redux";
import axios from "axios";
import { Controls, Player } from "@lottiefiles/react-lottie-player";
import { json, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import { adminapiUrl, apiUrl, appname } from "../Utils/constants";
import { getContentData, getContentTypeByCategoryUid } from "../Utils/content";
const ThankPage = () => {
  const [orderDetail, setOrderDetail] = useState();
  const [rewardDetail, setRewardDetail] = useState();
  const [rewardDetail2, setRewardDetail2] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [showComponent, setShowComponent] = useState(false);
  const [emailParamsExists, setEmailFromParams] = useState(false);

  const [categorySlug, setCategorySlug] = useState(null);
  const [categories, setCategories] = useState(null);
  const [catIds, setCatIds] = useState([]);

  const [showBooKnowCatIds, setShowBookNowCatIds] = useState([5,10]);
  const [bootcampIds, setBootcampIds] = useState([4,5,6]);

  const { category } = useParams();

  const [categoriesMap, setCategoriesMap] = useState({});

  const storeSel = useSelector((state) => state);
  const emailParam = storeSel.emailData?.emailStored;
  const authToken = storeSel.emailData?.token;
  const appParam = storeSel.emailData?.appStatue;
  const myObject = storeSel.UrlData.userDetails;
  const myRewardObject = storeSel.UrlData.rewardsDetails;

  const [appNameLink, setAppNameLink] = useState("sweat");

  const [keys2, setKeys] = useState([]);
  const selectedCategoryObj = categories?.find(cat => cat?.slug == categorySlug);
  const selectedAppName = getContentTypeByCategoryUid(selectedCategoryObj?.uid);

  let keys = Object.keys(myObject);
  if (myObject?.Discount > 0 && myRewardObject?.coins_Value > 0) {
    keys = [
      "Total Sessions",
      "startdate",
      "Expiry Date",
      "Amount",
      "Discount",
      "referral_amount",
      "Taxes",
      "Total Amount",
    ];
  } else if (myObject?.Discount > 0) {
    keys = [
      "Total Sessions",
      "startdate",
      "Expiry Date",
      "Amount",
      "Discount",
      "Taxes",
      "Total Amount",
    ];
  } else if (myRewardObject?.coins_Value > 0) {
    keys = [
      "Total Sessions",
      "startdate",
      "Expiry Date",
      "Amount",
      "referral_amount",
      "Taxes",
      "Total Amount",
    ];
  } else {
    keys = [
      "Total Sessions",
      "startdate",
      "Expiry Date",
      "Amount",
      "referral_amount",
      "Taxes",
      "Total Amount",
    ];
  }

  var orderData;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (emailParam) {
      setEmailFromParams(true);
    }
  }, [emailParam]);

  const userDetails = storeSel?.UrlData?.userDetails;
  const navigate = useNavigate();

  const closeWebView = () => {
    // Perform any necessary actions here

    // Send a message to the Flutter app to close the WebView
    if (appParam)
      window.flutter_inappwebview.callHandler("closeWebView", "close");
  };
  useEffect(() => {
    if (
      (userDetails && userDetails?.startdate === "null") ||
      userDetails?.startdate === null ||
      userDetails?.name === "null" ||
      userDetails?.name === null
    ) {
      const pathSegments = window.location.pathname.split("/");

      // Remove the last segment to go back one level
      pathSegments.pop();

      // Construct the new URL
      const newUrl = pathSegments.join("/");

      // Navigate to the new URL
      navigate(newUrl);
    }
  }, [userDetails]);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    // Show the component after the Lottie animation has finished playing
    const timeout2 = setTimeout(() => {
      setShowComponent(true);
    }, 3000);

    return () => {
      clearTimeout(timeout);
      clearTimeout(timeout2);
    };
  }, []);

  useEffect(() => {
    axios({
      method: "get",
      url: apiUrl + `/getTransactions/` + myObject.transactionuid + ``,
    }).then((response) => {
      setOrderDetail(response.data.data[0]);
    });
    axios({
      method: "get",
      url:
        apiUrl +
        `/get_rewards_transaction/` +
        myObject.transactionuid +
        `?event=paid_plan`,
    }).then((response) => {

      console.log("response => ", response?.data)
      setRewardDetail(response.data.data[0]);
      setRewardDetail2(response.data.data[1]);

      const rewardDetail = response.data.data[0];

      console.log("Reward Detail", rewardDetail);

      let keysLocal = []

      // alert(JSON.stringify(rewardDetail?.Discount))


      if(rewardDetail && rewardDetail?.referral_amount && myObject?.Discount > 0)
      {
          keysLocal = [
            "Total Sessions",
            "startdate",
            "Expiry Date",
            "Amount",
            "Discount",
            "referral_amount",
            "Taxes",
            "Total Amount",
          ];

        } else if (rewardDetail && rewardDetail?.referral_amount == null && myObject?.Discount > 0) {
          keysLocal = [
            "Total Sessions",
            "startdate",
            "Expiry Date",
            "Amount",
            "Discount",
            "Taxes",
            "Total Amount",
          ];
        } else if( rewardDetail && rewardDetail?.referral_amount && rewardDetail?.Discount == undefined) {
          keysLocal = [
            "Total Sessions",
            "startdate",
            "Expiry Date",
            "Amount",
            "referral_amount",
            "Taxes",
            "Total Amount",
          ];
        } 
        else {
          keysLocal = [
            "Total Sessions",
            "startdate",
            "Expiry Date",
            "Amount",
            // "referral_amount",
            "Taxes",
            "Total Amount",
          ];
        }

        setKeys(keysLocal);


      
    });
  }, []);

  useEffect(() => {
    // const queryParams = new URLq(window.location.search);

    // console.log("query_params => ", queryParams)

    // const catSlug = queryParams.get("category")

    if (category) setCategorySlug(category);

    console.log("Cat slug --->", category);

    const getCategories = async () => {

      const res = await axios.get(
        adminapiUrl+"/read_allbranch_alltypes_allplans",
        // "https://admin-api.bodyprocoach.com/admin/read_allbranch_alltypes_allplans",
        {
          headers: {
            "Content-Type": "application/json",
          },
          mode: "no-cors",
        }
      );

      const data = res.data.data;
      setCategories(data?.All_categories);
      if (data?.All_categories) {
        const cat_slug_map = {};
        const localCatIds = [];
        data?.All_categories.map((cat) => {
          localCatIds.push(cat?.uid);

          cat_slug_map[cat.slug] = getContentTypeByCategoryUid(cat?.uid);
          document.documentElement.style.setProperty(
            "--global-theme",
            "black"
          );
        });
        console.log("CAT SLUG MAP --> ", cat_slug_map);
        setCategoriesMap(cat_slug_map);
        setCatIds(localCatIds);
      }

      console.log("categories in sessions => ", data);
    };
    getCategories();
  }, [category]);

  useEffect(() => {
    if (categoriesMap && categorySlug) {

      const typeLocal = selectedAppName;


      if (typeLocal) {
        document.documentElement.style.setProperty("--global-theme", "black");
        setAppNameLink(typeLocal)
      }
    }
  }, [categorySlug, categoriesMap, selectedAppName]);

  return (
    <>
      {categoriesMap && categoriesMap[categorySlug] && (
        <>
          {isLoading && (
            <>
              <Player
                autoplay
                loop
                src={
                  getContentData(selectedAppName).paySuccessLottie
                }
                style={{ width: "700px", height: "700px" }}
              >
                <Controls
                  visible={false}
                  buttons={["play", "repeat", "frame", "debug"]}
                />
              </Player>
              <div className="thank-lottie-text">
                {/* <h1>Payment Completed..!</h1> */}
              </div>
            </>
          )}

          {showComponent && (
            <div className="thank-page">
              <div className="thank-heading">
                <p className="thank-first-line"></p>
                <h2>Thank You For Your Order</h2>
                <p className="thank-last-line"></p>
              </div>

              <div className="thank-content-container">
                <div className="thank-left-section">
                  <h3>Order Confirmation:</h3>
                  {/* {Object.entries(OrderObject).map(([key, value]) => (
              <div key={key} className="thank-left-list-item">
                <p>{key} :</p>
                <p className="thank-left-list-item-value">{value}</p>
              </div>
            ))} */}
                  <div className="thank-left-list-item">
                    <div className="order-div-box">
                      <span>Invoice ID: </span>
                      <p> {orderDetail?.invoiceid} </p>
                    </div>
                    <div className="order-div-box">
                      <span>Date: </span>
                      <p>
                        {" "}
                        {moment(
                          orderDetail?.updatedon
                            .replaceAll("-", "/")
                            .split(" ")[0],
                          "YYYY/MM/DD"
                        ).format("Do MMM YYYY")}{" "}
                      </p>
                    </div>
                    <div className="order-div-box">
                      <span>Time: </span>
                      <p>
                        {" "}
                        {moment(
                          orderDetail?.updatedon
                            .replaceAll("-", "/")
                            .split(" ")[1],
                          "HH:mm:ss"
                        ).format("h:mm A")}{" "}
                      </p>
                    </div>

                    {/* <span className="thank-left-list-item-value">
                <p> {orderDetail?.invoiceid} </p>
                <p>
                  {orderDetail?.updatedon.replaceAll("-", "/").split(" ")[0]}
                </p>
                <p>
                  {orderDetail?.updatedon.replaceAll("-", "/").split(" ")[1]}
                </p>
              </span> */}
                  </div>
                  {/* {orderData.map((data) => (
              <div key={data.key} className="thank-left-list-item">
                <span>{data.key}: </span>
                <span className="thank-left-list-item-value">{data.value}</span>
              </div>
            ))} */}

                  {!emailParamsExists && (
                    <>
                      <div className="qr-img-box">
                        <img
                          src={
                            getContentData(selectedAppName)
                              .appLinkQRCode
                          }
                          alt=""
                        />
                      </div>
                      <p>Scan the QR</p>
                      {/* <LineComp /> */}
                      <div className="appstore-img-box">
                        <a
                          href={
                            getContentData(selectedAppName)
                              .iosAppLink
                          }
                          target="_blank"
                        >
                          <img src="asset/Img/AppleImg.png" alt="" />
                        </a>
                        <a
                          href={
                            getContentData(selectedAppName)
                              .androidAppLink
                          }
                          target="_blank"
                        >
                          <img
                            className="google-play-img"
                            src="asset/Img/GoogleImg.png"
                            alt=""
                          />
                        </a>
                      </div>
                    </>
                  )}
                </div>

                <div className="thank-mid-section">
                  <h3>
                    {myObject["Plan Name"]} | {myObject.name}
                  </h3>
                  <div>
                 
                   {/* {JSON.stringify(keys2)}
                   {JSON.stringify(rewardDetail)} */}
                    {rewardDetail && keys2.map((value, index) => (
                      <div className="thank-mid-list-item">
                        <>
                          <p>
                            {/* {JSON.stringify( ["referral_amount"].includes(value) + value)} */}
                            {/* {JSON.stringify(value)} */}

                            {
                            ["startdate"].includes(value)
                              ? "Start Date"
                              : ["Total Sessions"].includes(value)
                              ? "Class Pack"
                              :
                               ["referral_amount"].includes(value)
                              ? "Coins Used"
                              : value
                            }

                            :
                          </p>
                          <p className="payment-list-item-row-value">
                            {["Amount", "Taxes", "Total Amount"].includes(value)
                              ? "₹"
                              : ""}

                            {
                            ["startdate"].includes(value)
                              ? moment(myObject[value], "YYYY/MM/DD").format(
                                  "Do MMM YYYY"
                                )
                              : ["Expiry Date"].includes(value)
                              ? moment(myObject[value], "YYYY/MM/DD").format(
                                  "Do MMM YYYY"
                                )
                              : myObject[value]
                            }

                            { ["referral_amount"].includes(value) &&
                            myRewardObject?.coins_Value > 0 ? (
                              <>
                                - ₹{myRewardObject?.coins_Value}{" "}
                                <img
                                  height={"15px"}
                                  src="asset/Img/coin.png"
                                  alt=""
                                />
                              </>
                            ) : (
                              ""
                            )}
                          </p>
                        </>
                      </div>
                    ))}
                  </div>

                 

                  {rewardDetail2?.referral_points > 0 && (
                    <center>
                      <div>
                        You get{" "}
                        <img height={"20px"} src="asset/Img/coin.png" alt="" />
                        {" " + rewardDetail2?.referral_points} coins on this
                        purchase
                      </div>
                    </center>
                  )}

                  <div className="thank-btn-div">
                    {/* <Button btnText="DOWNLOAD RECEIPT" /> */}
                    <a
                      target="_blank"
                      href={
                        getContentData(selectedAppName)
                          .downloadReceiptLink + myObject.transactionid
                      }
                    >
                      <button className="download-btn">
                        DOWNLOAD RECEIPT{" "}
                        <span>
                          <FontAwesomeIcon
                            className="Img-upload-edit-btn"
                            icon={faDownload}
                          />
                        </span>
                      </button>
                    </a>
                    {/* https://sweattpilates.in/appnav 

                    https://apps.apple.com/us/app/sweat-pilates/id6449866949
                  
                  */}

                    {showBooKnowCatIds.includes(
                      selectedCategoryObj?.uid
                    ) && (
                      <a
                        href={
                          emailParamsExists
                            ? `https://app.sweatfitwellness.com/timeTable?name=${appNameLink}`
                            : (authToken
                            ? `https://app.sweatfitwellness.com/timeTable?token=${authToken}&name=${appNameLink}`
                            : `https://app.sweatfitwellness.com/timeTable?name=${appNameLink}`)
                        }
                        target="_blank"
                      >
                        <Button
                          btnText="BOOK SLOTS NOW"
                          onClick={closeWebView}
                        />
                      </a>
                    )}
                    
                  </div>
                </div>
                <div className="thank-right-section">
                  <img
                    src="./asset/Img/sweat-payment-page.jpg"
                    alt=""
                  />
                </div>
              </div>
              <div className="download-app-text">
                <p>
                  <span>
                    <FontAwesomeIcon
                      className="Img-upload-edit-btn"
                      icon={faCircleInfo}
                    />
                  </span>{" "}
                  Download our app to book free slots and to keep a track of
                  your progress.
                </p>
              </div>
              <Footer />
            </div>
          )}
        </>
      )}
    </>
  );
};

export default ThankPage;
